import english from '../../lang/en.json';

const trans = function (str) {
  if (window.locale === 'en') {
    return english[str] || str;
  }

  return str;
};

export default trans;
